var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:[
		'nice-table-cell_status',
		("status-" + (_vm.item.status)),
		{
			'no-change': !_vm.canChange,
		}
	]},[(_vm.canChange)?_c('nice-action-list',{staticClass:"ni_table_c_status--ni_al",attrs:{"status":_vm.item.status,"list":_vm.list,"hide-on-click":_vm.hideOnClick,"icons-in-list":_vm.iconsInList,"tippy-trigger":_vm.tippyTrigger},on:{"change":_vm.change}}):[_c('nice-icon-2',{staticClass:"ni_table_c_status--label-icon",attrs:{"icon":_vm.currentItemFromList.icon}}),_c('span',{staticClass:"ni_table_c_status--label-status"},[_vm._v(_vm._s(_vm.$t('campaign.status_change_' + _vm.currentItemFromList.value)))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }